var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33332 22H31.6667C32.675 22 33.5 21.175 33.5 20.1667C33.5 19.1583 32.675 18.3333 31.6667 18.3333H2.33332C1.32498 18.3333 0.499985 19.1583 0.499985 20.1667C0.499985 21.175 1.32498 22 2.33332 22ZM2.33332 12.8333H31.6667C32.675 12.8333 33.5 12.0083 33.5 11C33.5 9.99167 32.675 9.16667 31.6667 9.16667H2.33332C1.32498 9.16667 0.499985 9.99167 0.499985 11C0.499985 12.0083 1.32498 12.8333 2.33332 12.8333ZM0.499985 1.83333C0.499985 2.84167 1.32498 3.66667 2.33332 3.66667H31.6667C32.675 3.66667 33.5 2.84167 33.5 1.83333C33.5 0.825 32.675 0 31.6667 0H2.33332C1.32498 0 0.499985 0.825 0.499985 1.83333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburger);
export default __webpack_public_path__ + "static/media/icon_hamburger.0e5ae0abf6acc4895e5933bfd0c1bd48.svg";
export { ForwardRef as ReactComponent };